<template>
  <div class="inner-height bg-white fixed overflow-auto top-0 bottom-0 left-0 right-0 z-10">
    <div class="relative h-full">
      <div
        class="fixed z-20 lg:hidden text-white bg-zt-primary-200 flex w-full document--header items-center px-6"
      >
        <button class="mr-auto text-zt-xl" @click="goBackToLicenses" data-vs-button="goBackToLicence">
          <zt-icon name="angle-left" />
        </button>
        <p class="w-full text-center text-zt-lg">
          {{$t('message.LincensesHistorySummaryComponent.header.title')}}
        </p>
      </div>
      <div class="p-10 pt-24">
        <div class="w-11/12 mx-auto">
          <div class="mx-auto pb-12 relative h-full" > <!-- style="height: calc(100vh - 206px);" -->
            <div class="mb-6">
              <label class="custom-color-neutral text-zt-base flex">{{ $t('message.LincensesHistorySummaryComponent.labels.licenseType2') }}</label>
              <label class="custom-color-neutral text-zt-lg">{{ request.tipo_alias }}</label>
            </div>

            <div class="flex flex-wrap">
              <div class="mb-6 width-49percent">
                <label class="custom-color-neutral text-zt-base flex">{{ $t('message.LincensesHistorySummaryComponent.labels.solicitudeState') }}</label>
                <label
                    :class="setColorByStatus(request.estado_id)"
                    class="custom-color-neutral text-zt-lg" >{{ getStatus(request) }}</label>
              </div>
              <div class="mb-6 width-49percent with-marginleft">
                <label class="custom-color-neutral text-zt-base flex">{{ $t('message.LincensesHistorySummaryComponent.labels.solicitudeDate') }}</label>
                <label class="custom-color-neutral text-zt-lg">{{ withoutHour(request.fecha) }}</label>
              </div>
            </div>

            <div class="mb-6">
              <label class="custom-color-neutral text-zt-base flex">{{ $t('message.LincensesHistorySummaryComponent.labels.approver') }}</label>
              <label class="custom-color-neutral text-zt-lg">{{ getApprover(request) }}</label>
            </div>

            <div class="flex flex-wrap mb-6">
              <div class="width-49percent">
                <label class="custom-color-neutral text-zt-base flex">{{ $t('message.LincensesHistorySummaryComponent.labels.startDate') }}</label>
                <label class="custom-color-neutral text-zt-lg">{{ request.fecha_desde }}</label>
              </div>
              <div class="width-49percent with-marginleft">
                <label class="custom-color-neutral text-zt-base flex">{{ $t('message.LincensesHistorySummaryComponent.labels.reincorporationDate') }}</label>
                <label class="custom-color-neutral text-zt-lg">{{ request.fecha_regreso }}</label>
              </div>
            </div>
            <div class="mb-6">
              <label class="custom-color-neutral text-zt-base flex">{{ $t('message.LincensesHistorySummaryComponent.labels.requestedDays') }}</label>
              <label class="custom-color-neutral text-zt-lg">{{ request.dias }}</label>
            </div>

            <div class="mb-2">
              <label class="custom-color-neutral text-zt-base flex">{{ $t('message.LincensesHistorySummaryComponent.labels.comment') }}</label>
              <p
                v-if="request.observaciones" 
                class="mt-2 mb-4 p-4 custom-color-neutral text-zt-lg border border-gray rounded h-40 overflow-auto"
                v-html="request.observaciones"></p>
            </div>

            <div v-if="request.license_has_document === 't' || request.upload_document === 't'" class="mb-4">
              <label class="custom-color-neutral text-zt-base flex mb-2">{{ $t('message.LincensesHistorySummaryComponent.labels.attachmentDocument') }}:</label>

              <button   v-if="request.license_has_document === 't'" class="w-full text-left custom-color-neutral border-button rounded border-gray p-4 wo-outline" data-vs-button="download" @click="downloadDocument()">
                <zt-icon name="download-paper-outline" class="mr-2 text-custom-2xl"></zt-icon>
                <span class="border-b color-custom-link">{{ $t("message.LicensesHistoryComponent.downloadDocument") }}</span>
              </button>
              <button v-if="request.upload_document === 't'"  class="w-full text-left custom-color-neutral border-button rounded border-gray p-4 wo-outline" data-vs-button="download" @click="openUploadFileModal()" >
                <zt-icon name="person cursor-pointer" class="mr-2 text-custom-2xl"></zt-icon>
                <span class="border-b color-custom-link">Adjuntar documento</span>
              </button>

            </div>


            <div class="z-20 absolute bottom-0 right-0 left-0" v-if="request.estado_id === '2' || request.estado_id === '3' || request.estado_id === '4'">
              <div class="mx-auto w-11/12">
                <zt-button @click="cancelLicense" class="w-full" :disabled="buttonDisabled" data-vs-button="cancelLicence">
                  {{ $t('message.LincensesHistorySummaryComponent.cancelButton') }}
                </zt-button>
              </div>
            </div>
            <div class="mb-2" v-if="request.estado_id === '5'">
              <label class="custom-color-neutral text-zt-base flex">{{ $t('message.LincensesHistorySummaryComponent.labels.addCalendar') }}</label>
              <div class="flex justify-center pt-2">
                <zt-button class="" data-vs-button="addCalendar" @click="openGoogleCalendar(request)">
                  {{ $t('message.LincensesHistorySummaryComponent.addCalendar') }} 
                </zt-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddFileModal
      :activeModal="activeModal"
      :licenceId="request.id"
      @close="activeModal = !activeModal"
      @closeModalandUpdateList="closeModalandUpdateList"
      @update:linkUsersModalActive="linkUsersModalActive = $event"/>
  </div>
</template>

<script>
import Licenses from "@/apiClient/Licenses";
import {find} from 'lodash';
import AddFileModal from "@/modules/Licenses/components/request/AddFileModal.vue";

export default {
  props: {
    request: {
      type: Object,
      default: {}
    }
  },
  components: {
    AddFileModal
  },
  data(){
    return{
      licenses: Licenses,
      buttonDisabled: false,
      activeModal: false,
      pdfFile: ''
      /* showBalance: false,
      balance: 0 */
    }
  },
  created(){
    this.licenses = new Licenses()
  },
  methods: {
    customErrorMessges(error){
        const err = error.response.data.response_v2;
        const code = err.code === 'La licencia no puede comenzar un dia feriado.' ? '02101' : err.code;
        const message = err.message;
        const sichernPeopleErrorCodeRegex = /^SICHERN_PEOPLE_[A-Z_]*_ABSENCE_BAD_REQUEST$/g.test(code);
        const handledMessages = ['StatusNotAllowed','ProcessedAbsenceExists', 'AbsenceNotExists','AbsenceStatusNotValidForOperation','ErrorDeletingReviewStatus','OnlyRejectedTheLastOpeningAbsence','InvalidDateRange']
        if (sichernPeopleErrorCodeRegex && handledMessages.some(x => x == message)) {
            return `${code}_${message}`;
        } else {
            return code;
        }
    },
    closeModalandUpdateList() {
     this.activeModal = false;
     this.goBackToLicenses();
    },
    goBackToLicenses(){
      this.$router.push({
        name: "licenses"
      });
    },
    openUploadFileModal() {
      let fakemetadata =  {
    "id": 36819,
    "id_categoria_tipo_empresa": 10162,
    "tipo": "pdf",
    "nombre": "AUSENCIA POR CUMPLEAÑOS DE FAMILIAR",
    "pais": "AR",
    "doc_sin_id": "f",
    "incremental": "f",
    "texto_mail": null,
    "visible": "f",
    "id_template": 1,
    "json": {
        "name": "GEN",
        "alias": "Generico",
        "files": [
            {
                "hash": "",
                "name": "Generico",
                "alias": "Generico",
                "order": 10,
                "value": "",
                "mimeType": "",
                "mandatory": true
            }
        ],
        "max_files": 20,
        "min_files": 1,
        "version_name": "CE1",
        "version_number": 1
    },
    "name": "CERTIFICADOS DE LICENCIAS"
}
      this.$store.commit('setUploadFilesMetaData',fakemetadata)
      this.activeModal = !this.activeModal
    },
    downloadDocument() {
      this.licenses.getUploadedDocument(this.request.id)
      .then(res => {
        const data_uri_prefix = 'data:application/pdf;base64,'
        const contentDisposition = res[0].headers['content-disposition'];
        const filename = contentDisposition.split(';')[1].split('=')[1].replace('"', '').replace('"', '');
        this.pdfFile = data_uri_prefix + res[1]
        this.pdfFileName = filename
      })
      .then(() => {
        const element = document.createElement('a')
        element.setAttribute('href', this.pdfFile)
        element.setAttribute('download', this.pdfFileName)
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)
      })
    },
    openGoogleCalendar(event) {
        const eventTitle = event.tipo_alias;
        const startDate = this.formatDate(event.fecha_desde); 
        const endDate = this.formatDate(event.fecha_regreso);

        const calendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${eventTitle}&dates=${startDate}/${endDate}`;

        window.open(calendarUrl, '_blank');
    },
    formatDate(date) {
        const [day, month, year] = date.split('/');
        const dateObj = new Date(Date.UTC(year, month - 1, day));

        const formattedYear = dateObj.getUTCFullYear();
        const formattedMonth = String(dateObj.getUTCMonth() + 1).padStart(2, '0'); 
        const formattedDay = String(dateObj.getUTCDate()).padStart(2, '0'); 
        
        return `${formattedYear}${formattedMonth}${formattedDay}`;
    },
    cancelLicense(){
      this.buttonDisabled = true
      this.$swal({
        title: this.$t('message.LincensesHistorySummaryComponent.modals.title'),
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
        buttonsStyling: false,
        cancelButtonClass: 'btn buttonSwallCancelProperties',
        confirmButtonClass: 'btn buttonSwallConfirmProperties',
        showLoaderOnConfirm: false,
        cancelButtonText: this.$t("message.HeaderComponent.logout.no"),
        confirmButtonText: this.$t("message.settingsComponent.list.okMsg"),
      }).then((result) => {
        if(result.value) {
          this.licenses.deleteRequestLicense(this.request.id).then(() => {
            this.$swal({
            type: 'success',
            title:  this.$t('message.LincensesHistorySummaryComponent.sumary.quitLicenseOk'),
            timer: this.$store.getters.getTimerSweetAlert,
            showConfirmButton: false,
            }).then(() => {
              this.$router.push({name: 'licenses'})
            })
          }).catch((error) => {
            this.buttonDisabled = false
            this.$swal({
              type: 'error',
              title: this.$t(`message.errorReference.${this.customErrorMessges(error)}`),
              showConfirmButton: true,
              confirmButtonText: this.$t("message.settingsComponent.list.okMsg"),
            })
          })
        }else{
          this.buttonDisabled = false
        }
      })
    },
    getStatus(item) {
      if(item.estado_id === '2' || item.estado_id === '3' || item.estado_id === '4'){
        return this.$t("message.LicensesHistoryComponent.statusPending")
      }else if(item.estado_id === '9') {
        return this.$t("message.LicensesHistoryComponent.statusExpired")
      }else{
        return item.estado_alias
      }
    },
    setColorByStatus(id) {
      const config = [
        { id: '2', fontColor: 'text-zt-warning'},
        { id: '3', fontColor: 'text-zt-warning'},
        { id: '4', fontColor: 'text-zt-warning'},
        { id: '5', fontColor: 'text-zt-success'},
        { id: '8', fontColor: 'text-zt-danger'},
        { id: '9', fontColor: 'text-zt-dark-400'},
        { id: '10', fontColor: 'text-zt-dark-400'}
      ];
      const response = find(config, { id })
      return response ? response.fontColor : 'text-zt-dark-400'
    },
    withoutHour: value => {
      return value.split(" ")[0]
    },
    getApprover: item => {
      if(item.estado_id === '4') {
        return 'RRHH'
      }else{
        return item.en_manos_de.toLowerCase().split(' ')
            .map((word) => {
              return word
                  .split('')
                  .map((char, index) => {
                    if (index === 0) return char.toUpperCase();
                    return char;
                  })
                  .join('');
            }).join(' ');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.document--header {
  height: 64px;
}
.custom-bg{
  background-color: #898dff;
}
.width-49percent{
  width: 49%;
}
.with-marginleft{
  margin-left: 2%;
}
::v-deep .v-text-field--outline {
  .v-input__slot {
    border: 2px solid rgba(255, 255, 255, 0.87) !important;
  }
  textarea {
    color: white !important;
  }
}
@function vh($quantity) {
  @return calc(var(--vh, 1vh) * #{$quantity});
}
.inner-height {
  height: vh(100);
}
.border-gray {
  border: solid 1px #d9dcde;
}
.color-custom-link {
  color: #0179b6;
  border-color: #0179b6;
}
.text-custom-2xl {
  font-size: 36px;
}
.wo-outline {
  outline: none;
}
</style>